import { dashboardConstants } from "../constants";

export function dashboard(state = {}, action) {
  switch (action.type) {
    case dashboardConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case dashboardConstants.GET_LAYOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        widgets: action.dashboard
      };

    case dashboardConstants.GET_WIDGET_DATA_REQUEST:
      if (state.widgets && state.widgets.rows && state.widgets.rows.length) {
        state.widgets.rows.forEach((row, index) => {
          row.forEach((widget, index) => {
            if (widget.WidgetId === action.widgetId) {
              widget["loading"] = true;
              widget["granularity"] = action.granularity;
              widget["data"] = null;
            }
          });
        });
      }
      return { ...state };

    case dashboardConstants.GET_WIDGET_DATA_SUCCESS:
      if (state.widgets && state.widgets.rows && state.widgets.rows.length) {
        state.widgets.rows.forEach((row, index) => {
          row.forEach((widget, index) => {
            if (widget.WidgetId === action.widgetId) {
              widget["loading"] = false;
              widget["data"] = action.data;
            }
          });
        });
      }
      return { ...state };

    case dashboardConstants.GETALL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}
